import * as React from 'react'
import MotionFlex from '../MotionFlex'
import { Link } from '@chakra-ui/core'
import { H5, Text } from '../../typography'
import { CoachSession } from '../../generated/graphql'
import dayjs from 'dayjs'

type Props = {
  coachSessions: CoachSession[]
}

const UpcomingAppointments: React.FC<Props> = ({ coachSessions }) => {
  return (
    <MotionFlex
      mt={5}
      p={5}
      flexDir="column"
      shadow="md"
      borderWidth="1px"
      bg="white"
      width={['100%', 'unset']}
    >
      <H5>UPCOMING APPOINTMENTS</H5>
      {coachSessions.map((session) => (
        <MotionFlex
          key={session.documentId!}
          width="100%"
          flexDirection="row"
          border="solid 1px"
          borderColor="brand.100"
          borderRadius={3}
          my={3}
        >
          <MotionFlex
            flexDirection="column"
            backgroundColor="brand.100"
            p="2"
            px="4"
            alignItems="center"
          >
            <Text fontSize={['13px', '17px']}>
              {dayjs(session?.appointment?.appointment_start_date as string).format('D')}
            </Text>
            <Text fontSize={['13px', '17px']} fontWeight="700">
              {dayjs(session?.appointment?.appointment_end_date as string).format('MMM')}
            </Text>
          </MotionFlex>

          <MotionFlex width="100%" flexDir="row">
            <MotionFlex flexDirection="column" p="2" px="4" width="95%">
              <Link href={`${session?.appointment?.appointment_url}`} isExternal>
                <Text fontWeight="700" fontSize="22px" mr={1}>
                  {session.title}
                </Text>
              </Link>
              <Text fontSize={['13px', '17px']}>
                <Text fontWeight="700" fontSize={['13px', '17px']} mr={1}>
                  Time:
                </Text>
                {dayjs(session?.appointment?.appointment_start_date as string).format('h:mm A')} -{' '}
                {dayjs(session?.appointment?.appointment_end_date as string).format('h:mm A')}
              </Text>
            </MotionFlex>
          </MotionFlex>
        </MotionFlex>
      ))}
    </MotionFlex>
  )
}

export default UpcomingAppointments
